export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? // FIXME: note if we deploy with jhucapp-dev, the login is not going to work!
      "https://jhucapp.herokuapp.com" /* Env variable is not playing well with GitHub Action */
    : // "https://jhucapp-dev.herokuapp.com" /* Env variable is not playing well with GitHub Action */
      process.env.REACT_APP_API_BASE_URL_DEV;
